var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import CustomSlider from '../../CustomSlider';
import VASRequestCard from './VASRequestCard';
var VASRequestSectionContent = function (_a) {
    var vasRequestCards = _a.vasRequestCards, customSliderProps = _a.customSliderProps;
    return (React.createElement("div", { className: "lfc-w-full lfc-pt-6" }, (vasRequestCards !== null && vasRequestCards !== void 0 ? vasRequestCards : []).length <= 2 ? (React.createElement("div", { className: "lfc-flex lfc-items-stretch ".concat(vasRequestCards.length === 2 ? 'lfc-gap-x-4' : '') }, (vasRequestCards !== null && vasRequestCards !== void 0 ? vasRequestCards : []).map(function (requestCard, index) { return (React.createElement("div", { key: index, className: "".concat(vasRequestCards.length === 2 ? 'lfc-w-1/2' : 'lfc-w-fit') },
        React.createElement(VASRequestCard, __assign({ key: index }, requestCard)))); }))) : (React.createElement(CustomSlider, __assign({ sliderProps: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
        }, hideArrows: (vasRequestCards !== null && vasRequestCards !== void 0 ? vasRequestCards : []).length <= 2 }, customSliderProps),
        React.createElement(React.Fragment, null, (vasRequestCards !== null && vasRequestCards !== void 0 ? vasRequestCards : []).map(function (requestCard, index) { return (React.createElement(VASRequestCard, __assign({ key: index }, requestCard))); }))))));
};
export default VASRequestSectionContent;
//# sourceMappingURL=VASRequestSectionContent.js.map